import React, { FC, useMemo } from 'react';
import { Address } from 'ia-react-core/~/interfaces/Address';
import useTranslation from '../../../hooks/useTranslation';
import { StyledWrapper } from './AddressFormat.styles';

export interface AddressFormatProps {
  children?: Address;
  address?: Address;
}

const AddressFormat: FC<AddressFormatProps> = ({ children, address }) => {
  const resolvedAddress = useMemo(() => address || children, [address, children]);
  const { t } = useTranslation('Core.AddressFormat');
  if (!resolvedAddress) return null;

  return (
    <StyledWrapper>
      {(resolvedAddress.ruralRoute || resolvedAddress.poBoxNumber || resolvedAddress.place) && (
        <div>
          {resolvedAddress.ruralRoute ? `${t('ruralRouteLabel')} ${resolvedAddress.ruralRoute}` : ''}
          {resolvedAddress.poBoxNumber ? `${t('poBoxLabel')} ${resolvedAddress.poBoxNumber}` : ''}
          {resolvedAddress.place ? ` ${t('placeLabel')} ${resolvedAddress.place}` : ''}
        </div>
      )}
      <div>{resolvedAddress.subBuilding ? `${resolvedAddress.subBuilding}-` : ''}{resolvedAddress.buildingNumber} {resolvedAddress.street}</div>
      <div>{resolvedAddress.city} {resolvedAddress.province} {resolvedAddress.postalCode}</div>
      <div>{resolvedAddress.countryName}</div>
    </StyledWrapper>
  );
};

export default AddressFormat;
